import { ICustomer } from "opp-api-lib-js";
import { AnyAction, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import OGSAPI from "../utils/OGSAPI";

export const REFRESH_CUSTOMER: string = "auth/REFRESH_CUSTOMER";
export const FETCHING_CUSTOMER: string = "auth/FETCHING_CUSTOMER";
export const FETCHED_CUSTOMER: string = "auth/FETCHED_CUSTOMER";
export const REFRESHED_CUSTOMER: string = "auth/REFRESHED_CUSTOMER";

export interface IState {
    customer: ICustomer | undefined;
    refreshing: boolean;
}

const initialState: IState = {
    customer: undefined,
    refreshing: false,
};

export function refreshCustomer(): ThunkAction<Promise<ICustomer>, IState, {}> {
    return (dispatch: Dispatch<IState>): Promise<ICustomer> => {
        const promise = new Promise<ICustomer>((
            yes: (customer: ICustomer) => void,
            no: () => void,
        ): void => {
            OGSAPI.fetchCurrentCustomer().then((customer: ICustomer) => {
                yes(customer);
            }, no);
        });

        dispatch({ type: FETCHING_CUSTOMER });

        promise.then(
            (customer: ICustomer) => {
                dispatch({ type: FETCHED_CUSTOMER, customer });
            },
        );

        return promise;
    };
}

interface IHandleFetchedCustomerAction extends AnyAction {
    customer: ICustomer;
    type: string;
}

export const actions = {
    // @ts-ignore
    refreshCustomer: refreshCustomer as () => Promise<ICustomer>,
};

function handleFetchedCustomer(state: IState, action: IHandleFetchedCustomerAction): IState {
    const { customer } = action;

    return {
        ...state,
        customer,
    };
}

export default function reducer(state: IState, action: AnyAction): IState {
    if (!state) {
        return initialState;
    }

    switch (action.type) {
        case FETCHED_CUSTOMER:
            return handleFetchedCustomer(state, action as IHandleFetchedCustomerAction);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ducks/auth.ts